import React from 'react';
import { useLocale } from 'locale';
import {
  Body,
  PropertyDetailsText,
  TagsWrapper,
} from 'ds/components/ListingCard';
import {
  FirstLineLabel,
  LineLabels,
  SecondLineLabel,
  ThirdLineLabel,
  FirstLineWrapper,
  CommercialTag,
  MarketplaceTypeLabel,
  CommercialBulletinPromotion,
} from '../styled';
import { AgentTags } from '../AgentTags';
import { BreakpointValue } from 'consts/breakpoints';
import NotificationTag from '../NotificationTag';
import { useUniversalCardAddress } from '../utils';
import { CommercialBulletinUniversalCardProps, ExtraProps } from 'components/cards/types';
import { CommercialBulletinLine } from 'components/labelLineItem/commercial-bulletin-line';


export interface UniversalCommercialBulletinCardProps extends CommercialBulletinUniversalCardProps, ExtraProps {
  breakpoint: BreakpointValue;
  carousel: JSX.Element;
  handleOnMouseEnter: () => void;
  handleOnMouseLeave: () => void;
}

const UniversalCommercialBulletinCard: React.FC<UniversalCommercialBulletinCardProps> = (props) => {

  const localeProps = useLocale();
  const { t, formatMoney } = localeProps;
  const {
    withPaddingBottom,
    city,
    notificationTags,
    carousel,
    handleOnMouseEnter,
    handleOnMouseLeave,
    buildingClass,
    size,
    floor,
    area,
    price,
    qualityClass,
    generalCondition,
    showMarketplaceType,
    showPromotion,
    streetName,
    streetNumber,
    neighbourhood,
    unitNumber,
    resolutionPreferences,
    isSearchInWholeCountry,
    hideTags,
  } = props;

  const [ notificationTag ] = notificationTags || [];
  const isOnSeparateLine = Boolean(props.isExclusive && props.madadSearchResult);

  const primaryAddress = useUniversalCardAddress(
    streetName,
    streetNumber,
    neighbourhood,
    unitNumber,
    city,
    resolutionPreferences,
    isSearchInWholeCountry
  );

  return (
    <div onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
      {carousel}
      <Body withPaddingBottom={withPaddingBottom} className="universal-card-body-wrapper">
        {showMarketplaceType ? (
          <MarketplaceTypeLabel isCommercial>
            {t('listingCard.marketplaceTypeLabel', { isCommercial: true })}
          </MarketplaceTypeLabel>
        ) : null}
        {showPromotion ? (
          <CommercialBulletinPromotion>
            {t('listingCard.commercialBulletinPromotion')}
          </CommercialBulletinPromotion>
        ) : null}
        <LineLabels data-auto="property-details">
          <FirstLineLabel isHighlighted={false} weight="bold">
            <FirstLineWrapper
              data-auto="property-price"
              isFlexColumn={isOnSeparateLine}
            >
              {formatMoney(props.price)}
              {props.isAgent ? (
                <AgentTags
                  isExclusive={props.isExclusive}
                  isOnSeparateLine={isOnSeparateLine}
                />
              ) : null}
            </FirstLineWrapper>
          </FirstLineLabel>
          <SecondLineLabel>
            <CommercialBulletinLine
              area={area}
              price={price}
              size={size}
              floor={floor}
              buildingClass={buildingClass}
            />
          </SecondLineLabel>
          <ThirdLineLabel>
            <PropertyDetailsText>
              {primaryAddress}
            </PropertyDetailsText>
          </ThirdLineLabel>
          {notificationTag && city ? <PropertyDetailsText faded>{city}</PropertyDetailsText> : null}
        </LineLabels>
        {notificationTag ? (
          <NotificationTag tag={notificationTag} />
        ) : null}
        {!hideTags && !showMarketplaceType && (generalCondition || qualityClass) ? (
          <TagsWrapper className="tags-wrapper">
            {generalCondition ? <CommercialTag>{t('filters.conditionsOptions', { value: generalCondition })}</CommercialTag> : null}
            {qualityClass ? <CommercialTag>{t('commercial.listing.offerDetails.qualityClass', { value: qualityClass })}</CommercialTag> : null}
          </TagsWrapper>
        ) : null}
      </Body>
    </div>
  );
};

export default UniversalCommercialBulletinCard;
